import type { shoppingApi } from 'app/src/services/welfareportal'
import { Tag } from 'app/src/shared/components'
import { VoucherIcon } from 'app/src/shared/components/Icons'
import { useTranslation } from 'app/src/shared/hooks'

export function GoodAndServiceLeftPanelSide(
  props: { order: shoppingApi.OrderDetails; statusMode?: boolean; className?: string } & {
    showUsageModal: boolean
    setShowUsageModal: (flg: boolean) => void
  },
) {
  const { t } = useTranslation('shopping', { keyPrefix: 'Direct' })

  return (
    <div className={props.className ?? 'col-span-12 flex flex-wrap justify-end gap-10 p-2 lg:col-span-6 lg:pr-8'}>
      <div className='flex flex-row'>
        <div>
          <VoucherIcon />
        </div>
        <div className='pl-4'>
          <div>
            {typeof props.statusMode !== 'undefined' && props.statusMode ? (
              <Tag
                pt={{
                  root: {
                    className: `mt-0 mb-0 h-[28px] ${(props.order.status === 'canceled' || props.order.status === 'rejected') && 'bg-[#fae8eb] text-[#BF0B20]'}`,
                  },
                }}
                tag={t('StateMapping')[props.order.status]?.label}
              />
            ) : (
              t('GoodAndService.productDescription')
            )}
          </div>
          <div
            className='mt-4 max-w-lg text-2xl font-bold'
            dangerouslySetInnerHTML={{ __html: props.order.product?.productName ?? '' }}
          />
          {/* <CatalogSummaryButtonInformativeDialog
            setShowModal={props.setShowUsageModal}
            showModal={props.showUsageModal}
            bannerId='VOUCHERUSAGE'
          /> */}
        </div>
      </div>
    </div>
  )
}
